{
  "dashboard": "Dashibodi ya Serikali",
  "applications": "Maombi",
  "oversight": "Usimamizi wa Daftari",
  "dashboard_page": {
    "title": "Muhtasari wa Dashibodi",
    "subtitle": "Usimamizi wa Ufikiaji wa DNA wa Serikali",
    "admin_user": "Mtumiaji Msimamizi",
    "stats": {
      "registered_projects": "Miradi Iliyosajiliwa",
      "pending_approvals": "Idhini Zinazosubiri",
      "credits_issued": "Mikopo Iliyotolewa",
      "active_transfers": "Uhamisho Unaotumika",
      "pending_applications": "Maombi Yanayosubiri",
      "certificates_issued": "Vyeti Vilivyotolewa",
      "active_projects": "Miradi Inayoendelea",
      "open_grievances": "Malalamiko Wazi"
    },
    "quick_actions": {
      "application_queue": {
        "title": "Foleni ya Maombi",
        "pin": "Ujumbe wa Taarifa za Mradi",
        "pdd": "Hati ya Usanifu wa Mradi",
        "authorization": "Ombi la Idhini",
        "pending": "Inasubiri",
        "review": "Mapitio",
        "approved": "Imeidhinishwa"
      },
      "recent_certificates": {
        "title": "Vyeti vya Hivi Karibuni",
        "credit_registration": "Usajili wa Mikopo",
        "letter_authorization": "Barua ya Idhini",
        "credit_cancellation": "Kufutwa kwa Mikopo",
        "issued": "Imetolewa",
        "processing": "Inasindika"
      }
    },
    "registry_overview": {
      "title": "Usimamizi wa Daftari",
      "verified_emissions": "Uzalishaji Uliothibitishwa",
      "retired_credits": "Mikopo Iliyostaafishwa",
      "pending_transfer": "Uhamisho Unasubiri",
      "tco2e": "tCO2e",
      "credits": "Mikopo"
    },
    "ndc_allocation": {
      "title": "Mgao wa NDC",
      "total_allocation": "Mgao Jumla",
      "renewable_energy": "Nishati Mbadala",
      "forestry": "Misitu",
      "agriculture": "Kilimo"
    },
    "buffer_account": {
      "title": "Akaunti ya Akiba",
      "national_buffer": "Akiba ya Kitaifa",
      "transaction_account": "Akaunti ya Muamala",
      "available_credits": "Mikopo Inayopatikana"
    },
    "pending_approvals": {
      "title": "Idhini za Mradi Zinazosubiri",
      "view_all": "Tazama Maombi Yote",
      "project_id": "Kitambulisho cha Mradi",
      "project_name": "Jina la Mradi",
      "developer": "Msanidi",
      "submitted": "Imewasilishwa",
      "type": "Aina",
      "status": "Hali",
      "actions": "Vitendo",
      "review": "Mapitio",
      "approve": "Idhinisha",
      "reject": "Kataa",
      "under_review": "Inakaguliwa",
      "documentation_required": "Nyaraka Zinahitajika",
      "technical_review": "Mapitio ya Kiufundi"
    },
    "international_transfers": {
      "title": "Uhamisho wa Kimataifa",
      "view_all_transfers": "Tazama Uhamisho Wote",
      "transfer_id": "Kitambulisho cha Uhamisho",
      "from_country": "Kutoka Nchi",
      "to_country": "Kwenda Nchi",
      "credits": "Mikopo",
      "date": "Tarehe",
      "status": "Hali",
      "authorize": "Idhinisha",
      "authorized": "Imeidhinishwa",
      "pending_authorization": "Idhini Inasubiri"
    },
    "registry_insights": {
      "title": "Ufahamu wa Daftari",
      "total_projects": "Jumla ya Miradi",
      "this_month": "mwezi huu",
      "compliance_rate": "Kiwango cha Uzingatiaji",
      "avg_processing_time": "Muda wa Wastani wa Usindikaji",
      "days": "siku"
    }
  },
  "register_page": {
    "title": "Usajili wa Serikali / DNA",
    "subtitle": "Usimamizi wa kiutawala na udhibiti wa ufikiaji kwa Mamlaka Maalum ya Kitaifa",
    "dna_requirements": {
      "title": "Mahitaji ya Mamlaka ya DNA",
      "official_designation": "Uteuzi rasmi wa serikali kama DNA",
      "unfccc_coordination": "Uratibu wa daftari la kitaifa la UNFCCC",
      "legal_authority": "Mamlaka ya kisheria ya usimamizi wa soko la kaboni",
      "article6_mandate": "Mamlaka ya utekelezaji wa Kifungu cha 6"
    },
    "admin_functions": {
      "title": "Kazi za Utawala",
      "project_approval": "Idhini na uidhinishaji wa mradi",
      "registry_oversight": "Usimamizi na ufuatiliaji wa daftari",
      "transfer_authorization": "Idhini ya uhamisho wa kimataifa",
      "compliance_enforcement": "Zana za kufuata na kutekeleza"
    },
    "access_levels": {
      "title": "Viwango vya Ufikiaji",
      "observer": {
        "title": "Mwangalizi",
        "description": "Ufikiaji wa kusoma tu wa daftari"
      },
      "administrator": {
        "title": "Msimamizi",
        "description": "Usimamizi kamili wa udhibiti"
      }
    },
    "application_process": {
      "title": "Mchakato wa Maombi",
      "step1": "Wasilisha barua rasmi ya uteuzi wa DNA",
      "step2": "Toa nyaraka za idhini za UNFCCC",
      "step3": "Kamilisha mahitaji ya ujumuishaji wa kiufundi",
      "step4": "Pitia uhakiki wa usalama"
    },
    "contact_info": {
      "title": "Kwa maswali ya usajili wa DNA, tafadhali wasiliana na:",
      "email": "Barua pepe",
      "phone": "Simu",
      "office_hours": "Saa za kazi: Jumatatu - Ijumaa, 9:00 AM - 5:00 PM UTC"
    },
    "actions": {
      "request_access": "Omba Ufikiaji wa Tovuti ya DNA",
      "download_requirements": "Pakua Hati ya Mahitaji"
    },
    "registration_status": "Usajili wa ufikiaji wa serikali unaendelezwa kwa sasa. Tafadhali rudi baadaye.",
    "buttons": {
      "register_new_dna": "Sajili DNA Mpya",
      "access_existing_portal": "Fikia Tovuti Iliyopo"
    }
  },
  "sidebar": {
    "portal_title": "Tovuti ya Ufikiaji wa DNA",
    "portal_subtitle": "Dashibodi ya Serikali",
    "dashboard": "Dashibodi",
    "application_queue": "Foleni ya Maombi",
    "certificates": "Vyeti",
    "registry_oversight": "Usimamizi wa Daftari",
    "grievance_management": "Usimamizi wa Malalamiko",
    "doe_licenses": "Leseni za DOE",
    "unfccc_reporting": "Ripoti za UNFCCC",
    "administration": "Utawala",
    "settings": "Mipangilio",
    "logout": "Toka"
  },
  "application_queue": {
    "title": "Foleni ya Maombi",
    "subtitle": "Maombi Yanayosubiri - PIN, PDD na Idhini",
    "filters": {
      "application_type": "Aina ya Maombi:",
      "all_types": "Aina Zote",
      "pin": "PIN",
      "pdd": "PDD",
      "authorization": "Idhini",
      "status": "Hali:",
      "all_status": "Hali Zote",
      "pending_review": "Inasubiri Mapitio",
      "under_review": "Inakaguliwa",
      "approved": "Imeidhinishwa",
      "rejected": "Imekataliwa",
      "date_range": "Kipindi cha Tarehe:",
      "to": "hadi",
      "filter": "Chuja"
    },
    "stats": {
      "total_applications": "Jumla ya Maombi",
      "pin_applications": "Maombi ya PIN",
      "pdd_applications": "Maombi ya PDD",
      "authorizations": "Idhini"
    },
    "table": {
      "title": "Maombi Yanayosubiri",
      "export": "Hamisha",
      "new_review": "Mapitio Mapya",
      "columns": {
        "application_id": "Kitambulisho cha Maombi",
        "type": "Aina",
        "project_name": "Jina la Mradi",
        "applicant": "Mwombaji",
        "submitted": "Imewasilishwa",
        "status": "Hali",
        "priority": "Kipaumbele",
        "actions": "Vitendo"
      },
      "priority": {
        "high": "Juu",
        "medium": "Kati",
        "low": "Chini"
      },
      "actions": {
        "review": "Mapitio",
        "details": "Maelezo",
        "reopen": "Fungua Tena"
      }
    },
    "pagination": {
      "showing": "Inaonyesha",
      "to": "hadi",
      "of": "ya",
      "results": "matokeo",
      "previous": "Iliyotangulia",
      "next": "Inayofuata"
    }
  },
  "certificates": {
    "title": "Utoaji wa Vyeti na Barua",
    "subtitle": "Toa hati za CR, LOA, na CCI",
    "action_buttons": {
      "issue_cr": "Toa Usajili wa Mikopo (CR)",
      "issue_loa": "Toa Barua ya Idhini (LOA)",
      "issue_cci": "Toa Kufutwa kwa Mikopo (CCI)"
    },
    "filters": {
      "search_placeholder": "Tafuta kwa Kitambulisho, Jina la Mradi, au Shirika",
      "all_certificate_types": "Aina Zote za Vyeti",
      "credit_registration": "Usajili wa Mikopo (CR)",
      "letter_authorization": "Barua ya Idhini (LOA)",
      "credit_cancellation": "Kufutwa kwa Mikopo (CCI)",
      "all_status": "Hali Zote",
      "draft": "Rasimu",
      "pending_approval": "Inasubiri Idhini",
      "issued": "Imetolewa",
      "cancelled": "Imefutwa",
      "filter": "Chuja"
    },
    "stats": {
      "total_issued": "Jumla Iliyotolewa",
      "cr_documents": "Hati za CR",
      "loa_documents": "Hati za LOA",
      "cci_documents": "Hati za CCI"
    },
    "table": {
      "title": "Vyeti na Barua za Hivi Karibuni",
      "columns": {
        "document_id": "Kitambulisho cha Hati",
        "type": "Aina",
        "project_name": "Jina la Mradi",
        "organization": "Shirika",
        "issue_date": "Tarehe ya Utoaji",
        "status": "Hali",
        "actions": "Vitendo"
      },
      "document_types": {
        "cr": "CR",
        "loa": "LOA",
        "cci": "CCI"
      }
    },
    "pagination": {
      "showing": "Inaonyesha",
      "of": "ya",
      "certificates": "vyeti",
      "previous": "Iliyotangulia",
      "next": "Inayofuata"
    }
  },
  "registry_oversight": {
    "title": "Usimamizi wa Daftari",
    "subtitle": "Ufuatiliaji wa mradi na usimamizi wa mikopo",
    "filters": {
      "all_project_types": "Aina Zote za Miradi",
      "renewable_energy": "Nishati Mbadala",
      "forestry": "Misitu",
      "agriculture": "Kilimo",
      "energy_efficiency": "Ufanisi wa Nishati",
      "all_developers": "Wasanidi Programu Wote",
      "all_status": "Hali Zote",
      "active": "Inayotumika",
      "pending": "Inasubiri",
      "suspended": "Imesitishwa",
      "all_standards": "Viwango Vyote",
      "vcs": "VCS",
      "gold_standard": "Kiwango cha Dhahabu",
      "cdm": "CDM",
      "apply_filters": "Tumia Vichujio",
      "export": "Hamisha"
    },
    "project_tags": {
      "title": "Lebo za Mradi",
      "article6_eligible": "Inastahiki Kifungu cha 6.2",
      "in_buffer": "Katika Hifadhi",
      "pending_transfer": "Inasubiri Uhamisho"
    },
    "account_ledger": {
      "verified_emissions": {
        "title": "Uzalishaji Uliothibitishwa",
        "total_verified": "Jumla Iliyothibitishwa",
        "this_month": "Mwezi Huu"
      },
      "retired_credits": {
        "title": "Mikopo Iliyostaafishwa",
        "total_retired": "Jumla Iliyostaafishwa"
      },
      "pending_transfer": {
        "title": "Inasubiri Uhamisho",
        "awaiting_transfer": "Inasubiri Uhamisho",
        "processing": "Inasindika"
      }
    },
    "projects_table": {
      "title": "Daftari la Mradi",
      "columns": {
        "project_id": "Kitambulisho cha Mradi",
        "type": "Aina",
        "developer": "Msanidi",
        "status": "Hali",
        "credits": "Mikopo",
        "tags": "Lebo",
        "actions": "Vitendo"
      }
    },
    "ownership_history": {
      "title": "Historia ya Umiliki",
      "credit_transfer": "Uhamisho wa Mikopo",
      "credit_issuance": "Utoaji wa Mikopo"
    },
    "pagination": {
      "showing": "Inaonyesha",
      "of": "ya",
      "projects": "miradi",
      "previous": "Iliyotangulia",
      "next": "Inayofuata"
    }
  },
  "grievance_management": {
    "title": "Usimamizi wa Malalamiko",
    "subtitle": "Fuatilia na usimamie malalamiko na malalamiko ya mradi",
    "new_grievance": "Malalamiko Mapya",
    "stats": {
      "open_grievances": "Malalamiko Wazi",
      "under_investigation": "Chini ya Uchunguzi",
      "resolved_this_month": "Imetatuliwa Mwezi Huu",
      "avg_resolution_time": "Muda wa Wastani wa Utatuzi",
      "days": "siku"
    },
    "filters": {
      "search_placeholder": "Tafuta malalamiko...",
      "all_status": "Hali Zote",
      "open": "Wazi",
      "under_investigation": "Chini ya Uchunguzi",
      "resolved": "Imetatuliwa",
      "closed": "Imefungwa",
      "all_priority": "Vipaumbele Vyote",
      "high": "Juu",
      "medium": "Kati",
      "low": "Chini",
      "all_projects": "Miradi Yote",
      "filter": "Chuja"
    },
    "grievance_list": {
      "title": "Malalamiko Yanayoendelea",
      "columns": {
        "grievance_id": "Kitambulisho cha Malalamiko",
        "project": "Mradi",
        "complainant": "Mlalamikaji",
        "category": "Jamii",
        "priority": "Kipaumbele",
        "status": "Hali",
        "date_submitted": "Tarehe ya Kuwasilishwa",
        "actions": "Vitendo"
      },
      "categories": {
        "environmental": "Mazingira",
        "social_impact": "Athari za Kijamii",
        "economic": "Kiuchumi",
        "procedural": "Kiutaratibu"
      },
      "roles": {
        "community_rep": "Mwakilishi wa Jamii",
        "local_farmer": "Mkulima wa Karibu",
        "traditional_leader": "Kiongozi wa Jadi",
        "ngo_representative": "Mwakilishi wa NGO"
      }
    },
    "pagination": {
      "showing": "Inaonyesha",
      "of": "ya",
      "grievances": "malalamiko",
      "previous": "Iliyotangulia",
      "next": "Inayofuata"
    }
  },
  "doe_licenses": {
    "title": "Leseni za DOE",
    "subtitle": "Usimamizi wa Leseni za Chombo cha Uendeshaji Kilichoteulewa",
    "new_license": "Leseni Mpya",
    "admin_user": "Mtumiaji Msimamizi",
    "search_filters": {
      "search_label": "Tafuta",
      "search_placeholder": "Tafuta kwa jina la shirika...",
      "status_label": "Hali",
      "all_status": "Hali Zote",
      "active": "Inayotumika",
      "pending": "Inasubiri",
      "suspended": "Imesitishwa",
      "expired": "Imeisha muda",
      "license_type_label": "Aina ya Leseni",
      "all_types": "Aina Zote",
      "validation": "Uthibitishaji",
      "verification": "Uhakiki",
      "both": "Zote mbili",
      "actions_label": "Vitendo",
      "filter": "Chuja",
      "export": "Hamisha"
    },
    "stats": {
      "total_licenses": "Jumla ya Leseni",
      "active_licenses": "Leseni Zinazotumika",
      "pending_review": "Zinasubiri Mapitio",
      "expiring_soon": "Zinaisha Hivi Karibuni"
    },
    "table": {
      "title": "Daftari la Leseni za DOE",
      "columns": {
        "organization": "Shirika",
        "license_id": "Kitambulisho cha Leseni",
        "type": "Aina",
        "contact": "Mawasiliano",
        "status": "Hali",
        "expiry_date": "Tarehe ya Kuisha",
        "actions": "Vitendo"
      },
      "status_labels": {
        "active": "Inayotumika",
        "pending": "Inasubiri",
        "expiring": "Inaisha"
      },
      "type_labels": {
        "validation": "Uthibitishaji",
        "verification": "Uhakiki",
        "both": "Zote mbili"
      }
    },
    "pagination": {
      "showing": "Inaonyesha",
      "to": "hadi",
      "of": "ya",
      "results": "matokeo",
      "previous": "Iliyotangulia",
      "next": "Inayofuata"
    }
  },
  "unfccc_reporting": {
    "title": "Mihamishaji ya Ripoti za UNFCCC",
    "subtitle": "Zalisha na hamisha ripoti za UNFCCC na muhtasari wa marekebisho",
    "admin_user": "Mtumiaji Msimamizi",
    "report_generation": {
      "title": "Zalisha Ripoti za UNFCCC",
      "export_all_reports": "Hamisha Ripoti Zote",
      "report_parameters": "Vigezo vya Ripoti",
      "reporting_period_label": "Kipindi cha Ripoti",
      "report_type_label": "Aina ya Ripoti",
      "report_types": {
        "full_report": "Ripoti Kamili",
        "summary_report": "Ripoti ya Muhtasari",
        "adjustment_report": "Ripoti ya Marekebisho"
      },
      "project_categories_label": "Makundi ya Miradi",
      "categories": {
        "all_categories": "Makundi Yote",
        "renewable_energy": "Nishati Mbadala",
        "forestry_land_use": "Misitu na Matumizi ya Ardhi",
        "agriculture": "Kilimo"
      },
      "article6_status_label": "Hali ya Kifungu cha 6.2",
      "article6_options": {
        "article6_eligible": "Inastahili Kifungu cha 6.2",
        "in_buffer": "Katika Hifadhi",
        "pending_transfer": "Inasubiri Uhamisho"
      }
    },
    "report_preview": {
      "title": "Maonyesho ya Ripoti",
      "estimated_report_size": "Ukubwa Unaokadiriwa wa Ripoti",
      "total_projects": "Jumla ya Miradi",
      "total_credits": "Jumla ya Mikopo",
      "last_updated": "Iliyosasishwa Mwisho",
      "generate_pdf_report": "Zalisha Ripoti ya PDF",
      "generate_excel_report": "Zalisha Ripoti ya Excel",
      "generate_csv_report": "Zalisha Ripoti ya CSV"
    },
    "corresponding_adjustments": {
      "title": "Muhtasari wa Marekebisho Yanayolingana",
      "refresh_data": "Onyesha Upya Takwimu",
      "stats": {
        "total_adjustments": "Jumla ya Marekebisho",
        "positive_adjustments": "Marekebisho Mazuri",
        "negative_adjustments": "Marekebisho Mabaya",
        "pending_adjustments": "Marekebisho Yanayosubiri",
        "tco2e": "tCO2e"
      },
      "table": {
        "columns": {
          "project_id": "Kitambulisho cha Mradi",
          "project_name": "Jina la Mradi",
          "sector": "Sekta",
          "adjustment_type": "Aina ya Marekebisho",
          "amount_tco2e": "Kiasi (tCO2e)",
          "status": "Hali",
          "date": "Tarehe"
        },
        "adjustment_types": {
          "positive": "Mazuri",
          "negative": "Mabaya"
        },
        "status_labels": {
          "processed": "Imesindikwa",
          "pending": "Inasubiri"
        }
      }
    },
    "export_history": {
      "title": "Historia ya Mihamishaji",
      "filter": "Chuja",
      "status": {
        "completed": "Imekamilika"
      },
      "download": "Pakua"
    }
  },
  "administration": {
    "title": "Utawala",
    "subtitle": "Usimamizi wa Watumiaji na Upangaji wa Mfumo",
    "admin_user": "Mtumiaji Msimamizi",
    "tabs": {
      "user_management": "Usimamizi wa Watumiaji",
      "sector_management": "Usimamizi wa Sekta",
      "ndc_allocation": "Mgao wa NDC",
      "buffer_accounts": "Akaunti za Hifadhi",
      "transaction_accounts": "Akaunti za Muamala"
    },
    "userManagement": {
      "title": "Usimamizi wa Watumiaji",
      "form": {
        "title": "Ongeza Mtumiaji Mpya",
        "labels": {
          "organizationName": "Jina la Shirika",
          "address": "Anwani",
          "contactNumber": "Nambari ya Mawasiliano",
          "pointOfContactName": "Jina la Mtu wa Mawasiliano",
          "role": "Jukumu",
          "contactEmail": "Barua pepe ya Mawasiliano",
          "phoneNumber": "Nambari ya Simu",
          "username": "Jina la Mtumiaji",
          "password": "Nenosiri"
        },
        "placeholders": {
          "organizationName": "Ingiza jina la shirika",
          "address": "Ingiza anwani",
          "contactNumber": "Ingiza nambari ya mawasiliano",
          "pointOfContactName": "Ingiza jina la mtu wa mawasiliano",
          "contactEmail": "Ingiza anwani ya barua pepe",
          "phoneNumber": "Ingiza nambari ya simu",
          "username": "Ingiza jina la mtumiaji",
          "password": "Ingiza nenosiri"
        },
        "buttons": {
          "addUser": "Ongeza Mtumiaji"
        }
      },
      "userList": {
        "title": "Simamia Watumiaji",
        "search": {
          "placeholder": "Tafuta watumiaji...",
          "allRoles": "Majukumu Yote"
        },
        "table": {
          "headers": {
            "organization": "Shirika",
            "contactPerson": "Mtu wa Mawasiliano",
            "role": "Jukumu",
            "email": "Barua pepe",
            "status": "Hali",
            "actions": "Vitendo"
          }
        },
        "pagination": {
          "showing": "Inaonyesha",
          "to": "hadi",
          "of": "ya",
          "results": "matokeo",
          "previous": "Iliyotangulia",
          "next": "Inayofuata"
        }
      },
      "roles": {
        "selectRole": "Chagua Jukumu",
        "admin": "Msimamizi",
        "reviewer": "Mkaguzi",
        "operator": "Mfanyakazi",
        "viewer": "Mtazamaji"
      },
      "status": {
        "active": "Inayotumika",
        "inactive": "Haijatumika"
      }
    },
    "sectorManagement": {
      "title": "Usimamizi wa Mbinu",
      "controls": {
        "title": "Usimamizi wa Mbinu",
        "buttons": {
          "addMethodology": "Ongeza Mbinu",
          "export": "Hamisha"
        },
        "filters": {
          "sectorLabel": "Chuja kwa Sekta",
          "allSectors": "Sekta Zote",
          "renewableEnergy": "Nishati Mbadala",
          "forestry": "Misitu",
          "agriculture": "Kilimo",
          "wasteManagement": "Usimamizi wa Taka",
          "transportation": "Usafiri",
          "industrial": "Viwandani",
          "waste": "Taka",
          "statusLabel": "Hali ya Idhini",
          "allStatus": "Hali Zote",
          "approved": "Imeidhinishwa",
          "notApproved": "Haijaidhinishwa",
          "underReview": "Inapitiwa",
          "searchLabel": "Tafuta",
          "searchPlaceholder": "Tafuta mbinu..."
        }
      },
      "approvedMethodologies": {
        "title": "Mbinu Zilizoidhinishwa kwa Mamlaka",
        "count": "Mbinu",
        "table": {
          "headers": {
            "methodologyId": "Kitambulisho cha Mbinu",
            "sector": "Sekta",
            "title": "Kichwa",
            "version": "Toleo",
            "approvalDate": "Tarehe ya Idhini",
            "actions": "Vitendo"
          }
        }
      },
      "nonApprovedMethodologies": {
        "title": "Mbinu HAZIJAIDHINISHWA kwa Mamlaka",
        "count": "Mbinu",
        "table": {
          "headers": {
            "methodologyId": "Kitambulisho cha Mbinu",
            "sector": "Sekta",
            "title": "Kichwa",
            "reason": "Sababu",
            "reviewDate": "Tarehe ya Mapitio",
            "actions": "Vitendo"
          }
        },
        "rejectionReasons": {
          "incompatiblePolicy": "Haiendani na sera ya kitaifa",
          "technicalRequirements": "Mahitaji ya kiufundi hayajakidhi"
        }
      },
      "sectorsNotApproved": {
        "title": "Sekta HAZIJAIDHINISHWA",
        "addButton": "Ongeza Sekta Iliyozuiliwa",
        "restrictions": {
          "permanentlyRestricted": "Imezuiliwa kwa Kudumu",
          "policyRestricted": "Imezuiliwa kwa Sera",
          "underReview": "Inapitiwa"
        },
        "sectors": {
          "coalMining": "Uchimbaji wa Makaa ya Mawe",
          "oilGasExtraction": "Uchimbaji wa Mafuta na Gesi",
          "nuclearEnergy": "Nishati ya Nyuklia"
        },
        "descriptions": {
          "coalMining": "Uchimbaji wa makaa ya mawe na shughuli zinazohusiana",
          "oilGasExtraction": "Uchimbaji wa petroli na gesi asilia",
          "nuclearEnergy": "Shughuli za uzalishaji wa nishati ya nyuklia"
        }
      }
    },
    "ndcAllocation": {
        "buttons": {
          "saveChanges": "Hifadhi Mabadiliko",
          "reset": "Rudisha"
        },
        "lastUpdated": "Imesasishwa mwisho:",
        "allocation": {
          "title": "Asilimia za Ugawaji wa NDC",
          "total": "Jumla:",
          "applyToAll": "Tumia kwa Sekta Zote"
        },
        "sectors": {
          "renewableEnergy": "Nishati Mbadala",
          "forestryLandUse": "Misitu na Matumizi ya Ardhi",
          "agriculture": "Kilimo",
          "transportation": "Usafiri",
          "industrialProcesses": "Michakato ya Viwandani",
          "wasteManagement": "Usimamizi wa Taka"
        },
        "bufferAccount": {
          "title": "Akaunti ya Buffer ya Kitaifa",
          "total": "Jumla:",
          "applyToAll": "Tumia kwa Sekta Zote"
        },
        "transactionAccount": {
          "title": "Akaunti ya Miamala ya Kitaifa",
          "total": "Jumla:",
          "applyToAll": "Tumia kwa Sekta Zote"
        },
        "placeholders": {
          "percentage": "%"
        }
      },
      "bufferAccounts": {
        "overview": {
          "totalBufferAllocation": "Jumla ya Mgawo wa Buffer",
          "activeSectors": "Sekta Ambazo Zinaendelea",
          "bufferCredits": "Krediti za Buffer"
        },
        "configuration": {
          "title": "Usanidi wa Akaunti ya Buffer",
          "saveChanges": "Hifadhi Mabadiliko"
        },
        "globalSettings": {
          "title": "Mipangilio ya Kimataifa ya Buffer",
          "applyToAllSectors": "Tumia kwa sekta zote",
          "globalPercentage": "Asilimia ya Kimataifa:"
        },
        "sectorSettings": {
          "title": "Mgawo wa Buffer Kwa Sekta Mahsusi",
          "enableSectorSpecific": "Wezesha mgawo wa sekta mahsusi"
        },
        "sectors": {
          "renewableEnergy": {
            "title": "Nishati Mbadala",
            "description": "Miradi ya jua, upepo, maji"
          },
          "forestryLandUse": {
            "title": "Misitu na Matumizi ya Ardhi",
            "description": "Miradi ya REDD+, ya kupanda miti"
          },
          "agriculture": {
            "title": "Kilimo",
            "description": "Kilimo endelevu, mifugo"
          },
          "wasteManagement": {
            "title": "Usimamizi wa Taka",
            "description": "Gesi ya maziko ya taka, kutengeneza mboji"
          },
          "manufacturing": {
            "title": "Utengenezaji",
            "description": "Ufanisi wa viwandani, kubadili mafuta"
          },
          "transport": {
            "title": "Usafiri",
            "description": "Mabadiliko ya njia, uboreshaji wa ufanisi"
          }
        },
        "summary": {
          "activeAllocations": {
            "title": "Mgawo wa Buffer Unaoendelea",
            "forestryCredits": "krediti katika buffer",
            "agricultureCredits": "krediti katika buffer",
            "transportCredits": "krediti katika buffer"
          },
          "activity": {
            "title": "Shughuli za Akaunti ya Buffer",
            "creditsAdded": "Krediti Zilizoongezwa",
            "creditsReleased": "Krediti Zilizoachiliwa",
            "netChange": "Mabadiliko ya Uwazi",
            "last30Days": "Siku 30 zilizopita"
          }
        }
      },
      "transactionAccounts": {
        "summary": {
          "totalAllocation": "Jumla ya Mgawo",
          "activeSectors": "Sekta Zinazoendelea",
          "remaining": "Zinazobaki"
        },
        "globalSettings": {
          "title": "Mipangilio ya Mgawo wa Kimataifa",
          "applyToAllSectors": "Tumia kwa Sekta Zote",
          "percentage": "Asilimia:",
          "sectorSpecificAllocation": "Mgawo wa Sekta Mahsusi",
          "buttons": {
            "reset": "Rudisha",
            "applyGlobal": "Tumia Kimataifa"
          }
        },
        "sectorAllocation": {
          "title": "Mgawo kwa Sekta",
          "buttons": {
            "addSector": "Ongeza Sekta",
            "saveChanges": "Hifadhi Mabadiliko"
          },
          "table": {
            "headers": {
              "sectorName": "Jina la Sekta",
              "currentAllocation": "Mgawo wa Sasa",
              "newAllocation": "Mgawo Mpya (%)",
              "status": "Hali",
              "actions": "Vitendo"
            }
          },
          "sectors": {
            "renewableEnergy": "Nishati Mbadala",
            "forestryLandUse": "Misitu na Matumizi ya Ardhi",
            "agriculture": "Kilimo",
            "wasteManagement": "Usimamizi wa Taka",
            "transportation": "Usafiri"
          },
          "status": {
            "active": "Inatumika",
            "pending": "Inasubiri",
            "inactive": "Haifanyi Kazi"
          }
        },
        "footer": {
          "totalAllocated": "Jumla Iliyogawiwa:",
          "remaining": "Zinazobaki:",
          "buttons": {
            "cancel": "Ghairi",
            "saveAllChanges": "Hifadhi Mabadiliko Yote"
          }
        }
      }
    }
  }